export default __webpack_public_path__ + "static/media/20_gallery.0f74711c.jpg";